// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"2cf2ebd9","153":"ba762229","473":"e1149c72","770":"a58e2d69"}[chunkId] + ".chunk.js";
};